export default __webpack_public_path__ + "ae7460f254cc554bf5707ce15f5c10a5.png";